export const stripTags = str => {
  if (str === null || str === '') return false;
  str = str.toString();
  return str.replace(/<[^>]*>/g, ' ');
};
